"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldContextKey = void 0;
exports.injectFieldContext = injectFieldContext;
exports.useFieldContextValue = useFieldContextValue;
const utils_1 = require("@codegrade/utils");
exports.FieldContextKey = 'cg-form-field-context';
function injectFieldContext() {
    return {
        [exports.FieldContextKey]: {
            default() {
                return () => ({
                    inputId: undefined,
                    descriptionId: undefined,
                    register: () => undefined,
                    deregister: utils_1.func.noop,
                });
            },
        },
    };
}
function useFieldContextValue() {
    return {
        fieldContext() {
            return this[exports.FieldContextKey]?.();
        },
    };
}
